(function($, w) {
    'use strict';
    
    if (!w.jQuery) {
        throw 'Tema: jQuery bulunamadı';
    }
    
    if (!w.Theme) {
        w.Theme = {};
    }

    w.Theme.common = {
        init: function() {
            this.eventListener();
            this.afterInit();
            this.createOverlay();
            if (window.matchMedia("(max-width: 1199px)").matches) {
                this.mobile.init()
            }
        },
        
        afterInit: function() {
            this.addToFavoritesFunction.init();
            this.initSlider('.page-products .products-content');
            this.initSlider('.similar-products .products-content');
            this.awningsImages();
            this.productImageSlider();
            this.caseStudyDetailCarousel();
        },

        initSlider: function (element) {
            if ($(element).length == 0) {
                return;
            }
            $(element).slick({
                autoplay: true,
                autoplaySpeed: 6000,
                arrows: true,
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 4,
                prevArrow: `
                    <button type="button" class="slick-prev" aria-label="Previous">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.92593 15L1.31482 8.42C1.21129 8.30515 1.1539 8.15537 1.1539 8C1.1539 7.84463 1.21129 7.69485 1.31482 7.58L7.92593 0.999999M18 8L1 8" stroke="#193236" stroke-width="1.5"/>
                        </svg>
                    </button>
                `,
                nextArrow: `
                    <button type="button" class="slick-next" aria-label="Next">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0741 1L16.6852 7.58C16.7887 7.69485 16.8461 7.84463 16.8461 8C16.8461 8.15537 16.7887 8.30515 16.6852 8.42L10.0741 15M0 8H17" stroke="#193236" stroke-width="1.5"/>
                        </svg>
                    </button>
                `,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            arrows: false,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: false,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            });
            $(element).on('afterChange', function(event, slick, currentSlide){
                if((slick.$slides.length - slick.options.slidesToShow) <= currentSlide){
                    $(element).slick('slickPause');
                    setTimeout(function(){
                        $(element).slick('slickGoTo',0);
                        $(element).slick('slickPlay');
                    }, $(element).slick('slickGetOption', 'autoplaySpeed'));
                }
            });
        },

        productImageSlider: function() {
            $('#case-study-primary-image').slick({
                autoplay: false,
                autoplaySpeed: 2000,
                arrows: true,
                dots: false,
                infinite: false,
                speed: 300,
                asNavFor: "#case-study-thumb-image",
                focusOnSelect: true,
                prevArrow: `
                      <button type="button" class="slick-prev" aria-label="Previous">
                          <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.92593 15L1.31482 8.42C1.21129 8.30515 1.1539 8.15537 1.1539 8C1.1539 7.84463 1.21129 7.69485 1.31482 7.58L7.92593 0.999999M18 8L1 8" stroke="#193236" stroke-width="1.5"/>
                          </svg>
                      </button>
                  `,
                  nextArrow: `
                      <button type="button" class="slick-next" aria-label="Next">
                          <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10.0741 1L16.6852 7.58C16.7887 7.69485 16.8461 7.84463 16.8461 8C16.8461 8.15537 16.7887 8.30515 16.6852 8.42L10.0741 15M0 8H17" stroke="#193236" stroke-width="1.5"/>
                          </svg>
                      </button>
                  `,
            });
        },
  
        caseStudyDetailCarousel: function (element) {
            $('#case-study-thumb-image').slick({
                vertical: false,
                arrows: false,
                slidesToShow: 8,
                slidesToScroll: 8,
                infinite: false,
                asNavFor: "#case-study-primary-image",
                focusOnSelect: true,
                responsive: [{
                    breakpoint: 424,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }]
            });
        },

        awningsImages: function (element) {
            $('.page-detail-images > div').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                autoplay : true,
                autoplaySpeed : 6000,
                arrows : false,
                dots: true,
                swipe: true,
                speed : 300,
                fade : true,
            });
            $('.page-tech-specs-banner-images > div').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                autoplay : true,
                autoplaySpeed : 6000,
                arrows : false,
                dots: true,
                swipe: true,
                speed : 300,
                fade : true,
            });
        },
      
        addToFavoritesFunction: {
            init: function () {
                this.addToFavorites();
            },

            addToFavorites: function() {
                const self = this;
                $('.add-my-favorites').each(function() {
                    const productId = $(this).data('product-id');
                    self.updateButtonState($(this), productId);
                });

                $('.add-my-favorites').click(function() {
                    const productId = $(this).data('product-id');
                    self.toggleFavorite($(this), productId);
                });
            },

            toggleFavorite: function(button, productId) {
                let favorites = JSON.parse(localStorage.getItem('favorites')) || [];

                if (!favorites.includes(productId)) {
                    favorites.push(productId);
                    console.log('Ürün favorilere eklendi!');
                } else {
                    favorites = favorites.filter(id => id !== productId);
                    console.log('Ürün favorilerden çıkarıldı!');
                }

                localStorage.setItem('favorites', JSON.stringify(favorites));
                this.updateButtonState(button, productId);
            },

            updateButtonState: function(button, productId) {
                let favorites = JSON.parse(localStorage.getItem('favorites')) || [];
                if (favorites.includes(productId)) {
                    button.addClass('favorite-product');
                } else {
                    button.removeClass('favorite-product');
                }
            }
        },

        plugins: {
            maskPhone: function(element) {
                $.each(element, function() {
                    var self = $(this);
                    $(this).mask('+44 zdd ddd ddddd', {
                        translation: {
                            'z': {
                                pattern: /[1-9]/
                            },
                            'd': {
                                pattern: /[0-9]/
                            }
                        },
                        onKeyPress: function(value) {
                            if (value.length > 1 && value.length < 3) {
                                self.val('+44')
                            }
                        }
                    })
                })
            }
        },

        mobile: {
			activeClass: 'active',
			menuRendered: false,
			mobileMenuId: 'mobile-navigation',

			init: function () {
				this.eventListener();
			},

			openSubCategories: function (element) {
				if (element.hasClass(this.activeClass)) {
					element.removeClass(this.activeClass);
				} else {
					element.addClass(this.activeClass);
				}
			},
            
			toggleNavigation: function () {
				if ($('body').hasClass('mobile-navigation-active')) {
					$('body').removeClass('mobile-navigation-active');
				} else {
					$('body').addClass('mobile-navigation-active');
				}
			},

			eventListener: function () {
				var self = this;
				$(document).on('click', '[data-selector="toggle-bar"]', function (e) {
					e.stopPropagation();
					self.toggleNavigation();
				});
				$(document).on('click', '#' + self.mobileMenuId + ' .has-sub-category a', function () {
					self.openSubCategories($(this).parent());
				});

				$(document).on('click', '.mobile-navigation-back', function () {
					self.closeSubCategories($(this).parent());
				});
			}

		},

        footerMenu: function(element) {
			var parentElement = element.parent();
			var containerElement = element.parents('.footer-menu-container');
			if(parentElement.hasClass('active')) {
				containerElement.find('.footer-menu').removeClass('active');
				parentElement.removeClass('active');
			} else {
				containerElement.find('.footer-menu').removeClass('active');
				parentElement.addClass('active');
			}
		},
      
        createOverlay: function () {
			$('body').append('<div class="navigation-menu-overlay" />');
		},
      
        eventListener: function() {
            var self = this;

            $(document).on('click tap', '[data-selector="openbox-close"]', function() {
                openBox.reset();
            });

            $(document).on('click tap', '.search > a', function() {
				setTimeout(function(){
                    $('.search-content input').focus();
                }, 100);
			});

            $(document).on('click tap', '[data-menu-type="accordion"] .footer-menu-title', function() {
				self.footerMenu($(this));
			});

            $('#ContactForm-phone').on('focus blur', function (e) {
                if (e.type === 'focus') {
                    Theme.common.plugins.maskPhone($(this))
                    $(this).val('+44 ');
                } else if (e.type === 'blur') {
                    if ($(this).val().length < 5) {
                        $(this).val('');
                    }
                }
            });
            $(document).on('click', '.page-specs-title a', function (event) {
                event.preventDefault();
                
                var target = $($.attr(this, 'href')); 
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - 50
                    }, 800);
                }
            });
        }
    };

    $(document).ready(function() {
        w.Theme.common.init();
    });
})(jQuery, window);